import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import format from 'date-fns/format';
import cn from 'classnames';
import { Table } from 'reactstrap';
import Pagination from 'components/molecules/pagination';
import common from 'constants/common';
import withLoaderTable from 'components/organisms/withLoader/withLoaderTable';
import StatusLog from 'components/molecules/patientStatusLog';

const PatientHoldingStatusLogs = ({ patientGuid, adminPage }) => {
  const loading = useSelector(
    (state) =>
      state.loading.effects.patientHoldingStatusLogs
        .getPatientHoldingStatusLogs,
  );
  const patientStatusLogs = useSelector(
    (state) => state.patientHoldingStatusLogs,
  );

  const {
    patientHoldingStatusLogs: {
      setPagePatientHoldingStatusLogs,
      getPatientHoldingStatusLogs,
      toggleOrder,
    },
  } = useDispatch();

  useEffect(() => {
    getPatientHoldingStatusLogs(patientGuid);
  }, [patientGuid]);

  const setPage = (pageOffset) => {
    setPagePatientHoldingStatusLogs({ pageOffset });
    getPatientHoldingStatusLogs(patientGuid);
  };

  const toggleReversed = () => {
    toggleOrder();
    getPatientHoldingStatusLogs(patientGuid);
  };

  return (
    <div className="patient-status-logs">
      <Table borderless border="0" cellSpacing="0" cellPadding="0">
        <thead>
          <tr>
            <th colSpan="3">
              <Pagination
                renderOrder
                reversedOnChange={toggleReversed}
                reversed={patientStatusLogs.reversed}
                title="Holding Status Log"
                page={patientStatusLogs.page}
                total={patientStatusLogs.totalCount}
                itemsPerPage={patientStatusLogs.pageStep}
                pageTotal={patientStatusLogs.data.length}
                handlePrevClick={() => setPage(-1)}
                handleNextClick={() => setPage(+1)}
                handleFirstClick={() => setPage(-(patientStatusLogs.page - 1))}
                handleLastClick={() =>
                  setPage(
                    Math.ceil(
                      patientStatusLogs.totalCount / patientStatusLogs.pageStep,
                    ) - patientStatusLogs.page,
                  )
                }
                loading={loading}
              />
            </th>
          </tr>
        </thead>
        {withLoaderTable(
          loading,
          <tbody className={cn({ 'gray-scrollbar': adminPage })}>
            {patientStatusLogs.data.map((patientStatusLog, index) => (
              <tr key={index} className={cn({ 'no-strip': adminPage })}>
                <td className="col-8 patient-status-logs__log">
                  <StatusLog patientStatusLog={patientStatusLog} />
                </td>
                <td className="col-4 patient-status-logs__date">
                  <span className={cn({ text: adminPage })}>
                    {patientStatusLog.createdAt
                      ? format(
                          new Date(patientStatusLog.createdAt),
                          common.dateFormats.short,
                        )
                      : ''}
                  </span>
                </td>
              </tr>
            ))}
          </tbody>,
        )}
      </Table>
    </div>
  );
};

PatientHoldingStatusLogs.propTypes = {
  patientGuid: PropTypes.string.isRequired,
  adminPage: PropTypes.bool,
};

export default PatientHoldingStatusLogs;
